<div>

    <div class="modal-header customBlueHeader" (click)="modal.dismiss('Cross click')">
        <p class="modal-title">Report Upload</p>
        <button type="button" class="close" aria-label="Close">
            <span aria-hidden="true">&times;</span>
        </button>
    </div>

    <div class="modal-body">

        <div class="flexBetween">
              <img
    src="https://cdn.pixabay.com/photo/2015/04/23/22/00/tree-736885_1280.jpg"
    style="max-width:100%;cursor:pointer"
    class="modal-hover-opacity"
  /> 
        </div>


    </div>

</div>